/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconStackFront = createReactComponent("stack-front", "IconStackFront", [
  [
    "path",
    { d: "M12 4l-8 4l8 4l8 -4l-8 -4", fill: "currentColor", key: "svg-0" }
  ],
  ["path", { d: "M8 14l-4 2l8 4l8 -4l-4 -2", key: "svg-1" }],
  ["path", { d: "M8 10l-4 2l8 4l8 -4l-4 -2", key: "svg-2" }]
]);

export { IconStackFront as default };
//# sourceMappingURL=IconStackFront.js.map
